<div class="fcb-widget">
  <!-- Loading -->
  <div *ngIf="loading" class="fcb-state">
    <i class="pi pi-spin pi-spinner"></i>
    <span>{{ 'FLEXI_COMPLIANCE.LOADING' | translate }}</span>
  </div>

  <!-- Empty state — Flexi enabled but no completed review yet -->
  <div *ngIf="!loading && !hasData" class="fcb-state">
    <i class="pi pi-chart-pie"></i>
    <p>{{ 'FLEXI_COMPLIANCE.BUSINESS_WIDGET.EMPTY' | translate }}</p>
  </div>

  <!-- Populated — the whole card opens the full OHS Compliance page -->
  <div *ngIf="!loading && hasData"
       class="fcb-grid fcb-grid--clickable"
       role="button"
       tabindex="0"
       (click)="openCompliance()"
       (keyup.enter)="openCompliance()"
       [title]="'FLEXI_COMPLIANCE.BUSINESS_WIDGET.OPEN' | translate">
    <div class="fcb-chart">
      <ngx-charts-pie-chart
        [view]="view"
        [scheme]="colorScheme"
        [customColors]="customColors"
        [results]="chartData"
        [gradient]="gradient"
        [legend]="showLegend"
        [labels]="showLabels"
        [doughnut]="isDoughnut">
      </ngx-charts-pie-chart>
      <div class="fcb-chart__score" [ngClass]="smileyClass()">
        <strong>{{ percentage }}%</strong>
      </div>
    </div>

    <div class="fcb-meta">
      <ul class="fcb-chips">
        <li class="fcb-chip is-green">
          <span class="fcb-chip__dot"></span>
          <strong>{{ green }}</strong>
          {{ 'FLEXI_COMPLIANCE.RATINGS.GOOD' | translate }}
        </li>
        <li class="fcb-chip is-yellow">
          <span class="fcb-chip__dot"></span>
          <strong>{{ yellow }}</strong>
          {{ 'FLEXI_COMPLIANCE.RATINGS.NEEDS_IMPROVEMENT' | translate }}
        </li>
        <li class="fcb-chip is-red">
          <span class="fcb-chip__dot"></span>
          <strong>{{ red }}</strong>
          {{ 'FLEXI_COMPLIANCE.RATINGS.MISSING' | translate }}
        </li>
        <li class="fcb-chip is-gray" *ngIf="unrated > 0">
          <span class="fcb-chip__dot"></span>
          <strong>{{ unrated }}</strong>
          {{ 'FLEXI_COMPLIANCE.RATINGS.UNRATED' | translate }}
        </li>
      </ul>
      <div class="fcb-total">
        {{ total }} {{ 'FLEXI_COMPLIANCE.BUSINESS_WIDGET.CHECKPOINTS' | translate }}
      </div>
      <div class="fcb-open">
        {{ 'FLEXI_COMPLIANCE.BUSINESS_WIDGET.OPEN' | translate }}
        <i class="pi pi-arrow-right"></i>
      </div>
    </div>

    <!-- Score face, right of the breakdown.
         MUST stay the last flex child. The parent wraps, and flexbox wraps the
         LAST child first — with the face in the middle it was the chips /
         checkpoint total / "Open OHS Compliance" link that dropped to a second
         line and got clipped by the card, so the card appeared to lose them.
         Last means a narrow card wraps the emoji instead of the content.
         Its own child rather than an overlay on the donut: the hole already
         holds the percentage, and the two would fight for it.
         Hidden entirely when the review has no score bucket — a missing score
         is not the same as a bad one, and defaulting to a sad face would state
         a result that does not exist. -->
    <div class="fcb-face" *ngIf="faceImage" [ngClass]="smileyClass()">
      <img class="fcb-face__img"
           [src]="faceImage"
           [alt]="faceLabelKey | translate"
           [title]="(faceLabelKey | translate) + ' — ' + percentage + '%'" />
    </div>
  </div>
</div>
